export default __webpack_public_path__ + "static/media/user_male.552f26ee.svg";